// extracted by mini-css-extract-plugin
module.exports = {"confirmContainer":"game-participation-confirmation-page_confirmContainer__2G-rv"};